module.exports = __webpack_public_path__ + "startpage-746fed5a/template-6-preview-4ffb1c5bb2567b7d7022d04206e7d66d.jpg";